<template>
  <div class="NavigationBar__Container">
    <div class="NavigationBar__Bar">
      <NavigationButton
        :name="$t('navigation-home')"
        :icon="'home'"
        :selected="step === 0"
        @clicked="displayWarning = !displayWarning"
      />
      <NavigationLine
        :selected="step >= 1"
      />
      <NavigationButton
        :name="$t('navigation-shape')"
        :selected="step === 1"
        :icon="'shape'"
        @clicked="SelectStep(1)"
      />
      <NavigationLine
        :selected="step >= 2"
      />
      <NavigationButton
        :name="$t('navigation-texture')"
        :selected="step === 2"
        :icon="'texture'"
        @clicked="SelectStep(2)"
      />
      <NavigationLine
        :selected="step >= 3"
      />
      <NavigationButton
        :name="$t('navigation-save')"
        :icon="'save'"
        :selected="step === 3"
        @clicked="SelectStep(3)"
      />
    </div>
    <div
      class="ClosingWindow"
      v-if="displayWarning"
      @click="displayWarning = false"
    />
    <div
      class="WarningBox_Container"
      v-show="displayWarning"
    >
      <div class="WarningBox">
        <div class="WarningBox_Text">
          <p class="WarningBox_Text_Text">
            {{ $t('navigation-warning') }}
          </p>
        </div>
        <div class="WarningBox_Buttons">
          <button
            class="WarningBox_Button"
            @click="displayWarning = false"
          >
            {{ $t('navigation-warning-cancel') }}
          </button>
          <button
            class="WarningBox_Button_Black"
            @click="SelectStep(0)"
          >
            {{ $t('navigation-warning-confirm') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import NavigationButton from './components/NavigationButton'
import NavigationLine from './components/NavigationLine'
import { EventBus } from '@/event-bus.js'

export default {
  data () {
    return {
      displayWarning: false
    }
  },
  mounted () {
    EventBus.$on('NextStep', () => {
      const newStep = this.step + 1
      this.SelectStep(newStep)
    })
    EventBus.$on('LogoClicked', () => {
      this.displayWarning = true
    })
  },
  beforeDestroy () {
    EventBus.$off('NextStep')
    EventBus.$off('LogoClicked')
  },
  components: {
    NavigationButton,
    NavigationLine
  },
  computed: {
    ...mapGetters(['step'])
  },
  methods: {
    SelectStep (step) {
      this.$store.dispatch('SetStep', step)
    }
  }
}
</script>

<style scoped>
.NavigationBar__Container {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    pointer-events: none;
}
@media screen and (min-width: 1300px) {
.NavigationBar__Bar {
    width: 25%;
    height: 75px;
    position: absolute;
    bottom: 1em;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    pointer-events: auto;
}
}
@media screen and (max-width: 1300px) {
.NavigationBar__Bar {
    width: 42%;
    height: 75px;
    position: absolute;
    bottom: 0px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    pointer-events: auto;
}
}

.WarningBox_Container{
    width: 1px;
    height: 100px;
    position: absolute;
    bottom: 75px;
    margin-left: 0px;
    margin-bottom: 1em;
    display:flex;
    justify-content: center;
    padding-bottom: 1em;
}

.WarningBox{
    width: 300px;
    height: 100px;
    background: white;
    border-radius: 5px;
    position: absolute;
    top: 0;
    left: -150px;
    pointer-events: auto;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12);
}

.WarningBox_Text {
  justify-content: center;
  height: 50%;
  display: flex;
  padding:1em;
  box-sizing: border-box;
}

.WarningBox_Text_Text {
  text-align: center;
  align-self: center;
  margin: auto;
  font-size: 0.8em;
  font-weight: 400;
}

.WarningBox_Buttons {
  display: flex;
  flex-direction: row;
  display: flex;
  height: 50%;
  padding-left:1em;
  padding-right:1em;
}

.WarningBox_Button{
  margin: auto;
  border: 1px black solid;
  padding: 0.5em 2.5em 0.5em 2.5em;
  border-radius: 5px;
}

.WarningBox_Button_Black{
  margin: auto;
  background: black;
  color: white;
  padding: 0.5em 2.5em 0.5em 2.5em;
  border-radius: 5px;
}

.ClosingWindow{
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  pointer-events: auto;
}
</style>
